























export default {
  name: 'VersionsTable',
  data: () => ({
    headers: [
      {
        text: 'Nom de la version',
        align: 'left',
        sortable: false,
        value: 'name',
      },
      { text: 'Nombre d\'utilisateurs', value: 'nbUsers' },
      { text: 'Nombre d\'appels API', value: 'nbAPICalls' },
      { text: 'Utilisateurs (%)', value: 'percentUsers' },
    ],
    values: [
      {
        name: 'Skraper-V0.1',
        nbUsers: 2,
        nbAPICalls: 14000,
        percentUsers: '1.2%',
      },
      {
        name: 'Skraper-V0.2',
        nbUsers: 8,
        nbAPICalls: 18000,
        percentUsers: '5%',
      },
      {
        name: 'Skraper-V0.3',
        nbUsers: 6,
        nbAPICalls: 14000,
        percentUsers: '3%',
      },
      {
        name: 'Skraper-V0.4',
        nbUsers: 4,
        nbAPICalls: 14000,
        percentUsers: '2.4%',
      },
      {
        name: 'Skraper-V0.5',
        nbUsers: 2,
        nbAPICalls: 14000,
        percentUsers: '1.2%',
      },
      {
        name: 'Skraper-V0.6',
        nbUsers: 10,
        nbAPICalls: 14000,
        percentUsers: '12%',
      },
      {
        name: 'Skraper-V1.0',
        nbUsers: 25,
        nbAPICalls: 14000,
        percentUsers: '24%',
      },
      {
        name: 'Skraper-V1.2',
        nbUsers: 118,
        nbAPICalls: 14000,
        percentUsers: '84%',
      },
    ],
  }),
};
